export const FILE = 'file';
export const POST = 'post';
export const LIVESTREAM = 'livestream';
